import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledIndicator = styled.div`
  position: absolute;
  bottom: -13px;
  right: 13px;
  color: white;
  padding: 4px 8px;
  border-radius: 32px;
  z-index: 1;

  background: ${Colors.error};
  &.is-correct {
    background: ${Colors.success};
  }
`;
